import { mapActions, mapMutations, mapGetters, mapStates } from './../baseModule'

const collection = 'docs'
const singleName = 'doc'
const pluralName = 'docs'
const connection = 'docs'

const model = {
  'referenceId': '',
  'collection': '',
  'createdAt': new Date(),
  'updatedAt': new Date(),
  '_attachments': {}
}
const validations = {
  database: { required: true },
  referenceId: { required: true },
  collection: { required: true }
}

export default {
  namespaced: true,
  state: {
    ...mapStates(),
    loading: true,
    all: [],
    one: Object.assign({}, model),
    validations: validations
  },
  mutations: {
    ...mapMutations()
  },
  actions: {
    ...mapActions(collection, model, connection)
  },
  getters: {
    ...mapGetters(),
    [singleName]: function (state) {
      return Object.assign({}, model, state.one)
    },
    [pluralName]: function (state) {
      return state.all
    },
    loading: state => state.loading,
    validations: state => state.validations
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/docs.js